
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { PriceCategory } from "@/types/priceCategory";

interface EditPriceCategoryDialogProps {
  category: PriceCategory | null;
  onClose: () => void;
  onSave: () => void;
  onChange: (category: PriceCategory) => void;
}

export function EditPriceCategoryDialog({
  category,
  onClose,
  onSave,
  onChange,
}: EditPriceCategoryDialogProps) {
  if (!category) return null;

  return (
    <Dialog open={!!category} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar Grupo de Preço</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="prefix">Prefixo</Label>
            <Input
              id="prefix"
              value={category.prefix}
              onChange={(e) =>
                onChange({
                  ...category,
                  prefix: e.target.value.toUpperCase(),
                })
              }
              maxLength={3}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="name">Nome do Grupo</Label>
            <Input
              id="name"
              value={category.name}
              onChange={(e) =>
                onChange({
                  ...category,
                  name: e.target.value,
                })
              }
            />
          </div>

          <div className="space-y-2">
            <Label>Tipo de Preço</Label>
            <RadioGroup
              value={category.price_type}
              onValueChange={(value) =>
                onChange({
                  ...category,
                  price_type: value as 'fixed' | 'range',
                  fixed_price: value === 'fixed' ? category.fixed_price : null,
                  min_price: value === 'range' ? category.min_price || 0 : undefined,
                  max_price: value === 'range' ? category.max_price || 0 : undefined,
                })
              }
              className="flex space-x-4"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="fixed" id="fixed" />
                <Label htmlFor="fixed">Preço Fixo</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="range" id="range" />
                <Label htmlFor="range">Faixa de Preço</Label>
              </div>
            </RadioGroup>
          </div>

          {category.price_type === 'fixed' ? (
            <div className="space-y-2">
              <Label htmlFor="price">Preço Fixo ($)</Label>
              <Input
                id="price"
                type="number"
                value={category.fixed_price || 0}
                onChange={(e) =>
                  onChange({
                    ...category,
                    fixed_price: parseFloat(e.target.value),
                  })
                }
              />
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="min_price">Preço Mínimo ($)</Label>
                <Input
                  id="min_price"
                  type="number"
                  value={category.min_price || 0}
                  onChange={(e) =>
                    onChange({
                      ...category,
                      min_price: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="max_price">Preço Máximo ($)</Label>
                <Input
                  id="max_price"
                  type="number"
                  value={category.max_price || 0}
                  onChange={(e) =>
                    onChange({
                      ...category,
                      max_price: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
            </div>
          )}

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button onClick={onSave}>Salvar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
